// @flow

export const REQUEST_CREATE = 'CONVERT_POPUP/REQUEST_CREATE'
export const REQUEST_CREATED = 'CONVERT_POPUP/REQUEST_CREATED'
export const ERROR = 'CONVERT_POPUP/ERROR'
export const INIT = 'CONVERT_POPUP/INIT'
